/* @flow */

import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { NetgemApiEmitterType, RequestResponseMethodDefinitionType } from '../emitter';

import { logError } from '../../../../helpers/debug/debug';
import { createCustomNetworkErrorFromKey } from '../../../../libs/netgemLibrary/helpers/CreateCustomNetworkError';
import { updateBOProductId } from '../../../appConf/actions';
import { REDUX_MSG_REQUEST_BO_PERSONAL_DATA } from '../../constants';
import getRequestDetails from './helpers/requestCommon';
import { BO_API_PERSONAL_DATA, type BO_RESPONSE_WITH_ETAG } from './types/common';

const sendVideofuturPersonalDataRequest: (signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (distributorId, signal) =>
  (dispatch: Dispatch, getState: () => CombinedReducers, NetgemApiEmitter: NetgemApiEmitterType): Promise<void> => {
    const {
      appConfiguration: { mainDistributorId },
    } = getState();

    if (!mainDistributorId) {
      return Promise.reject(createCustomNetworkErrorFromKey('common.messages.errors.missing_distributor_id'));
    }

    // Object 'requestDetails' contains 'headers', 'method' and 'uri' parameters
    const requestDetails = getRequestDetails(getState, mainDistributorId, BO_API_PERSONAL_DATA);

    return NetgemApiEmitter.emit(REDUX_MSG_REQUEST_BO_PERSONAL_DATA, {
      ...requestDetails,
      signal,
    })
      .then(({ response }: BO_RESPONSE_WITH_ETAG) => {
        if (signal?.aborted) {
          return;
        }

        const {
          body: {
            data: { productId },
          },
        } = response;

        dispatch(updateBOProductId(productId.toString()));
      })
      .catch((error) => logError(`Error retrieving personal data for "${mainDistributorId}": ${error.message}`));
  };

export default sendVideofuturPersonalDataRequest;
